import React, { useEffect, useState } from "react";
import MenuItems from "./MenuItems/MenuItems";
import Appointments from "./Appointments/Appointments";
// import ErrorBoundary from "../ErrorBoundary";
import { useUserActions } from "../../providers/UserProvider";
import { ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";
import { useActiveRoomState } from "../../providers/ActiveRoomProvider";
import MobileHeader from "./MobileHeader/MobileHeader";
import Echo from "laravel-echo";
import { useUserState } from "../../providers/UserProvider";

import classes from "./ProtectedLayout.module.scss";
// import { BrowserView, MobileView } from "react-device-detect";

function ProtectedLayout({ children }) {
  const location = useLocation();
  const { setUser } = useUserActions();
  const user = useUserState();

  const userId = user?.user_login?.client_id;
  const activeRoom = useActiveRoomState();
  const [onlineMembers, setOnlineMembers] = useState([]);

  useEffect(() => {
    setUser();
    EchoPublic();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const newEcho = () => {
    const echo = new Echo({
      broadcaster: "pusher",
      key: "7890123456",

      wsHost: "push.sbm24.com",
      wssPort: 6001,
      wsPort: 6001,
      disableStats: true,
      forceTLS: true,
      //enabledTransports: ['wss'],
      authEndpoint: "https://sandbox.sbm24.net/broadcasting/auth",
      auth: {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token_echo")}`,
          Accept: "application/json",
        },
      },
    });
    return echo;
  };

  let PublicChannel = newEcho().join(`public-channel`);

  const EchoPublic = () => {
    PublicChannel.here((users) => {
      setOnlineMembers(users);
    })
      .joining((user) => {
        let existOnlineUser = onlineMembers.some((item) => item.id === user.id);
        if (!existOnlineUser && userId !== user.id) {
          onlineMembers.push(user);
          setOnlineMembers(onlineMembers);
        }
      })
      .leaving((user) => {
        if (userId !== user.id) {
          let newArr = onlineMembers.filter((item) => item.id !== user.id);
          setOnlineMembers(newArr);
        }
      });
  };

  const renderHeaderMobile = () => {
    return <MobileHeader />;
  };

  return (
    <div className={classes.mainFlexContainer}>
      {renderHeaderMobile()}
      <div
        className={
          activeRoom || location.pathname !== "/dashboard"
            ? `${classes.mainListItem} ${classes.hideListInResponsiveMode}`
            : classes.mainListItem
        }
      >
        <Appointments onlineMembers={onlineMembers} />
      </div>
      <main
        className={` ${
          activeRoom || location.pathname !== "/dashboard"
            ? `${classes.main} ${classes.showRoomInResponsiveMode} `
            : classes.main
        }`}
      >
        {/* <ErrorBoundary> */}
        {children}
        {/* </ErrorBoundary> */}
      </main>

      <div className={classes.mainMenuItem}>
        <MenuItems />
      </div>

      <ToastContainer />
    </div>
  );
}

export default ProtectedLayout;
